import { DesignToken } from '@design/design-tokens/themes/theme-names';
import { getThemeColorInHex } from '@design/design-tokens/themes/theme-utils';
import { StripeElementStyle } from '@stripe/stripe-js';
import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';

export const useStripeTheme = () => {
  const themeName = useThemeStore(state => state.themeName);

  const getThemeColor = (designToken: DesignToken) =>
    getThemeColorInHex(themeName, designToken);

  const stripeElementStyle: StripeElementStyle = {
    base: {
      color: getThemeColor('--text-default'),
      fontFamily: 'nort, sans-serif, Arial, sans-serif',
      fontSize: '16px',
      iconColor: getThemeColor('--icon-default'),
      backgroundColor: 'transparent',
      '::placeholder': {
        color: getThemeColor('--text-disabled'),
      },
      ':-webkit-autofill': {
        color: getThemeColor('--text-disabled'),
      },
    },
    invalid: {
      color: getThemeColor('--border-critical'),
      iconColor: getThemeColor('--icon-critical'),
    },
  };

  return stripeElementStyle;
};
